import { type ReactNode } from "react";
import { Trans } from "react-i18next";

export type Attribute = {
  symbol: ReactNode;
  name: ReactNode;
};

const BSA_ATTRIBUTE_CODES = [
  "borediameter",
  "outsidediameter",
  "mass",
  "width",
  "basicdynamicloadratingradial",
  "basicstaticloadratingradial",
  "basicdynamicloadratingaxial",
  "basicstaticloadratingaxial",
  "temp",
];

const HSA_ATTRIBUTE_CODES = [
  "borediameter",
  "outsidediameter",
  "height",
  "length",
  "width",
  "housinghseat",
  "housingmdistance",
  "housingndistance",
  "basicdynamicloadratingradial",
  "basicstaticloadratingradial",
];

function makeAttributes(codes: string[]): Attribute[] {
  return codes.map((code) => ({
    name: <Trans i18nKey={`facet.${code}.name`} />,
    symbol: <Trans i18nKey={`facet.${code}.symbol`} />,
  }));
}

export const BSA_ATTRIBUTES: Attribute[] = makeAttributes(BSA_ATTRIBUTE_CODES);
export const HSA_ATTRIBUTES: Attribute[] = makeAttributes(HSA_ATTRIBUTE_CODES);
